import { InputRef, Row } from 'antd';
import React from 'react';

import { joinClassnames } from 'helpers/classNames';
import SearchCancel from '../../Atoms/SearchCancel';
import SearchIcon from '../../Atoms/SearchIcon';
import SearchInput from '../../Atoms/SearchInput';
import SearchPlaceholder from '../../Atoms/SearchPlaceholder';
import Styles from './SearchBox.module.scss';
import { TSearchBox } from './definitions';

const SearchBox: React.FC<TSearchBox> = ({
  onClick,
  isForm,
  show,
  setSearchMode,
  setSearchKeyword,
  userId,
  keyword,
}) => {
  const input = React.useRef<InputRef>(null);
  const [searchText, setSearchText] = React.useState('');

  React.useEffect(() => {
    if (!show) return;
    if (!input.current) return;
    input.current.focus();
  }, [show]);

  React.useEffect(() => {
    if (!setSearchMode) return;
    if (searchText.length === 0) {
      setSearchMode(false);
      if (setSearchKeyword) setSearchKeyword('');
    } else {
      setSearchMode(true);
      if (setSearchKeyword) setSearchKeyword(searchText);
    }
  }, [searchText]);

  const renderNormalButton = () => (
    <Row onClick={onClick} align="middle" className={Styles['search-button']}>
      <SearchIcon />
      <SearchPlaceholder />
    </Row>
  );

  const renderFormButton = () => (
    <Row
      align="middle"
      className={joinClassnames(Styles['search-button'], Styles['search-form'])}
    >
      <SearchIcon />
      <SearchInput
        ref={input}
        keyword={keyword}
        onChangeText={setSearchText}
        afterClick={onClick}
        userId={userId}
      />
      <SearchCancel onClick={onClick} />
    </Row>
  );

  const render = isForm ? renderFormButton : renderNormalButton;

  return <Row>{render()}</Row>;
};

export default SearchBox;
